import React, { useState } from 'react';
import styles from './LifeCarousel.module.css';

const images = [
  { id: 1, src: `${process.env.PUBLIC_URL}/images/life-gallery-1.jpg`, alt: 'Annie - Khoảnh khắc cuộc sống 1' },
  { id: 2, src: `${process.env.PUBLIC_URL}/images/life-gallery-2.jpg`, alt: 'Annie - Khoảnh khắc cuộc sống 2' },
  { id: 3, src: `${process.env.PUBLIC_URL}/images/life-gallery-3.jpg`, alt: 'Annie - Khoảnh khắc cuộc sống 3' },
];

/**
 * Life Carousel — displays Annie's life moments in a balanced carousel
 */
function LifeCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carousel}>
        <div className={styles.imageWrapper}>
          <img
            src={images[currentIndex].src}
            alt={images[currentIndex].alt}
            className={styles.image}
          />

          <button
            className={`${styles.navButton} ${styles.navButtonLeft}`}
            onClick={goToPrevious}
            aria-label="Ảnh trước"
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>

          <button
            className={`${styles.navButton} ${styles.navButtonRight}`}
            onClick={goToNext}
            aria-label="Ảnh tiếp theo"
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </div>
      </div>

      <div className={styles.dots}>
        {images.map((_, index) => (
          <button
            key={index}
            className={`${styles.dot} ${index === currentIndex ? styles.dotActive : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Đi tới ảnh ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default LifeCarousel;
